import {
  Users, BookOpen, ClipboardCheck, DollarSign,
  HeadphonesIcon, Shield, LayoutDashboard, Settings, UserPlus, FileText, GraduationCap, MessageSquare, CalendarCheck, MessageCircle,
} from "lucide-react";
import logo from "@/assets/logo.webp";
import { NavLink } from "@/components/NavLink";
import { useAuth } from "@/contexts/AuthContext";
import { useModuleVisibility } from "@/hooks/useModuleVisibility";
import {
  Sidebar, SidebarContent, SidebarGroup, SidebarGroupContent,
  SidebarGroupLabel, SidebarMenu, SidebarMenuButton, SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";

const allMenuItems = [
  { title: "Dashboard", url: "/dashboard", icon: LayoutDashboard, moduleKey: "dashboard" },
  { title: "Admission", url: "/admission", icon: UserPlus, moduleKey: "admission" },
  { title: "Administration", url: "/administration", icon: Users, moduleKey: "administration" },
  { title: "Academic", url: "/academic", icon: BookOpen, moduleKey: "academic" },
  { title: "Examination", url: "/examination", icon: ClipboardCheck, moduleKey: "examination" },
  { title: "Accounting", url: "/accounting", icon: DollarSign, moduleKey: "accounting" },
  { title: "Student Services", url: "/student-services", icon: HeadphonesIcon, moduleKey: "student_services" },
  { title: "Discipline", url: "/discipline", icon: Shield, moduleKey: "discipline" },
  { title: "Pre-Registration", url: "/student-pre-registration", icon: GraduationCap, moduleKey: "pre_registration" },
  { title: "Communication", url: "/communication", icon: MessageSquare, moduleKey: "communication" },
  { title: "User Management", url: "/user-management", icon: Settings, moduleKey: "user_management" },
  { title: "Attendance", url: "/attendance", icon: CalendarCheck, moduleKey: "attendance" },
  { title: "ChitChat", url: "/chitchat", icon: MessageCircle, moduleKey: "chitchat" },
  { title: "Audit Log", url: "/audit-log", icon: FileText, moduleKey: "audit_log" },
];

export function AppSidebar() {
  const { state } = useSidebar();
  const collapsed = state === "collapsed";
  const { roles } = useAuth();
  const { isModuleVisible } = useModuleVisibility(roles);

  const visibleItems = allMenuItems.filter(item => isModuleVisible(item.moduleKey));

  return (
    <Sidebar collapsible="icon">
      <SidebarContent>
        <div className="p-4 flex items-center gap-3">
          <img src={logo} alt="St. David College" className="h-10 w-10 rounded-full shrink-0 object-contain" />
          {!collapsed && (
            <div>
              <h2 className="font-bold text-sidebar-foreground text-sm leading-tight">St. David College</h2>
              <p className="text-xs text-sidebar-foreground/60">Health Sciences</p>
            </div>
          )}
        </div>

        <SidebarGroup>
          <SidebarGroupLabel>Modules</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {visibleItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild>
                    <NavLink
                      to={item.url}
                      className="hover:bg-sidebar-accent/50"
                      activeClassName="bg-sidebar-accent text-sidebar-primary font-medium"
                    >
                      <item.icon className="mr-2 h-4 w-4" />
                      {!collapsed && <span>{item.title}</span>}
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
